export default __webpack_public_path__ + "static/media/emoji-tick.47a8b88e.svg";